import React, { useEffect, useState } from "react";
import { ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CartDrawer = () => {
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();

  const refreshCart = () => {
    const items = JSON.parse(localStorage.getItem("cart") || "[]");
    setCart(items);
  };

  useEffect(() => {
    window.addEventListener("cart-updated", refreshCart);
    refreshCart();
    return () => window.removeEventListener("cart-updated", refreshCart);
  }, []);

  const itemCount = cart.reduce((sum, p) => sum + p.quantity, 0);

  if (itemCount === 0) return null;

  return (
    <div
      onClick={() => navigate("/cart")}
      className="cursor-pointer fixed bottom-3 left-1/2 transform -translate-x-1/2 w-[calc(100%-1.5rem)] max-w-md rounded-full flex justify-between items-center px-4 py-3 bg-blue-600 text-white shadow-xl"
    >
      <span className="flex items-center gap-2 text-sm font-semibold">
        <ShoppingCart size={18} />
        {itemCount} item{itemCount > 1 ? "s" : ""} in Quote
      </span>

      <span className="bg-blue-800 text-white px-4 py-1 rounded-full text-sm font-bold">
        View Quote
      </span>
    </div>
  );
};

export default CartDrawer;
